'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

define(['app', 'accessibilityFocusHelper'], function (app, accessibilityFocusHelper) {
  var skipToMainContent = function () {
    function skipToMainContent() {
      _classCallCheck(this, skipToMainContent);

      this.config = {
        skipLinkElementSelector: '.skipToMainContent_link',
        skipLinkPreferredTarget: '#main-content',
        skipLinkBackupTarget: '#mainContent',
        mainTag: 'main',
        westendHeader: '.westendHeader'
      };
    }

    _createClass(skipToMainContent, [{
      key: 'init',
      value: function init(skipLink) {
        if (!skipLink) return;

        this.target = this.getMostSuitableSkipTarget();

        // If target element exists then add event listener
        if (!!this.target) {
          skipLink.addEventListener('focus', this.trackFocus);
          skipLink.addEventListener('click', this.skipToTarget.bind(this));
          return skipLink;
        }
        // If target element does not exist then hide skip link -- IE compatible
        skipLink.remove();
        return skipLink;
      }
    }, {
      key: 'getMostSuitableSkipTarget',
      value: function getMostSuitableSkipTarget() {
        return document.querySelector(this.config.skipLinkPreferredTarget) || document.querySelector(this.config.skipLinkBackupTarget) || document.querySelector(this.config.mainTag) || null;
      }
    }, {
      key: 'skipToTarget',
      value: function skipToTarget(event) {
        event.preventDefault();
        this.trackClick();
        accessibilityFocusHelper.focus(this.target);
        this.target.scrollIntoView();
        var westendHeader = document.querySelector(this.config.westendHeader);
        westendHeader && window.scrollBy(0, -westendHeader.clientHeight);
      }
    }, {
      key: 'trackFocus',
      value: function trackFocus() {
        app.publish('columbo/track', 'Accessibility', 'Focused', 'SkipLink');
      }
    }, {
      key: 'trackClick',
      value: function trackClick() {
        app.publish('columbo/track', 'Accessibility', 'Clicked', 'SkipLink');
      }
    }]);

    return skipToMainContent;
  }();

  return skipToMainContent;
});
//# sourceMappingURL=skipToMainContent.js.map
